import { useQuery } from '@tanstack/react-query';
import { geoApi } from '../api/geo';
import { useTenantAuth } from '../stores/auth.tenant';

export function useGeoContext() {
  const tenant = useTenantAuth(state => state.tenant);
  return useQuery({
    queryKey: ['geo-context', tenant?.id],
    queryFn: geoApi.context,
    enabled: !!tenant && ['enterprise', 'government', 'group'].includes(tenant.tenant_type),
    staleTime: 60_000,
    retry: false,
  });
}
